module.exports = __webpack_public_path__ + "static/media/some_features.d3f27b1e.png";